<div class="m-2">
    <!-- Controls card: View toggle and action buttons -->
    <mat-card>
        <mat-card-content>
            <div style="display: flex; justify-content: space-between; align-items: center; gap: 8px;">
                <div style="display: flex; gap: 8px;">
                    <button mat-raised-button color="primary" (click)="openZohoWorkdrive()"
                            [hidden]="!application?.zohoworkdriveforcrm__Workdrive_Folder_ID" [disabled]="data?.isCollectorView">
                        <mat-icon>folder</mat-icon>
                        Workdrive
                    </button>
                    <button mat-raised-button color="primary"
                            [matMenuTriggerFor]="application?.Co_Appl_Required === 'Yes' ? menu : mainApplicant"
                            [disabled]="!canUploadDocuments"
                            [matTooltip]="!canUploadDocuments ? uploadDisabledMessage : ''"  [disabled]="data?.isCollectorView">
                        <mat-icon>upload</mat-icon>
                        Upload
                    </button>
                </div>
                <mat-button-toggle-group [(ngModel)]="currentView" aria-label="View Style"
                                            (change)="onViewChange()" color="primary" class="view-toggle">
                    <mat-button-toggle value="grid">
                        <mat-icon>grid_view</mat-icon>
                    </mat-button-toggle>
                    <mat-button-toggle value="list">
                        <mat-icon>view_list</mat-icon>
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </mat-card-content>
    </mat-card>

    <!-- Warning message when Account_Name is missing -->
    <mat-card *ngIf="!canUploadDocuments" class="mt-4" style="background-color: #fff3cd; border-left: 4px solid #ffc107;">
        <mat-card-content>
            <div style="display: flex; align-items: center; gap: 12px;">
                <mat-icon style="color: #ffc107;">warning</mat-icon>
                <div>
                    <strong>Agency information required</strong>
                    <p style="margin: 4px 0 0 0;">Please fill in the agency information before uploading documents.</p>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <!-- State display component - handles loading, empty, and error states -->
    <app-state-display
            *ngIf="showStateDisplay"
            [type]="stateType"
            loadingMessage="Loading documents..."
            emptyMessage="No documents uploaded"
            [errorMessage]="errorMessage || 'Failed to load documents'"
            emptyIcon="folder_open"
            errorIcon="error_outline">
    </app-state-display>

    <!-- Main content -->
    <div *ngIf="showContent">
        <mat-card class="mt-4">
            <mat-card-content>
                <mat-tab-group>
                    <mat-tab label="Main applicant">
                        <table mat-table [dataSource]="dataSourceMainAppDocuments"
                               *ngIf="currentView === 'list'" class="flat-table">
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef>Name</th>
                                <td mat-cell *matCellDef="let document">
                                    <a (click)="documentOnClick(document.id)" style="display: flex; align-items: center; gap: 8px;">
                                        <app-thumbnail
                                                [src]="document.thumbnailUrl"
                                                [alt]="document.name"
                                                [customStyle]="{height: '32px', width: '32px', 'object-fit': 'cover'}"
                                                [maxRetries]="5"
                                                [retryIntervalBase]="1000">
                                        </app-thumbnail>
                                        {{ document.name }}
                                    </a>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="type">
                                <th mat-header-cell *matHeaderCellDef>Type</th>
                                <td mat-cell *matCellDef="let document">{{ getDocumentType(document.type) }}</td>
                            </ng-container>

                            <ng-container matColumnDef="size">
                                <th mat-header-cell *matHeaderCellDef>Size</th>
                                <td mat-cell *matCellDef="let document">{{ document.size }}</td>
                            </ng-container>

                            <ng-container matColumnDef="uploadedInfo">
                                <th mat-header-cell *matHeaderCellDef>Uploaded</th>
                                <td mat-cell *matCellDef="let document">
                                    <div style="display: flex; flex-direction: column; gap: 4px;">
                                        <span style="font-weight: 500;">{{ document.uploadedBy }}</span>
                                        <span style="font-size: 0.85em; color: #666;">{{ document.uploadedAt | date:'y-MM-dd h:mm a' }}</span>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let document">
                                    <button mat-icon-button color="primary" (click)="downloadDocument(document.id); $event.stopPropagation()" matTooltip="Download">
                                        <mat-icon>download</mat-icon>
                                    </button>
                                    <button mat-icon-button color="warn"
                                            (click)="deleteDocument('MAIN_APPLICANT', document.type, document.name, document.id); $event.preventDefault(); $event.stopPropagation()" matTooltip="Delete" [disabled]="data?.isCollectorView">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsDocuments"></tr>
                            <tr mat-row *matRowDef="let document; columns: displayedColumnsDocuments"></tr>
                        </table>

                        <div *ngIf="currentView === 'grid'" class="documents-grid">
                            <mat-card class="document-content-card" *ngFor="let document of mainAppDocuments"
                                      (click)="documentOnClick(document.id)">
                                <div class="card-thumbnail">
                                    <app-thumbnail
                                            [src]="document.thumbnailUrl"
                                            [alt]="document.name"
                                            [maxRetries]="5"
                                            [retryIntervalBase]="1000">
                                    </app-thumbnail>
                                </div>
                                <mat-card-content>
                                    <h4 class="doc-name" [matTooltip]="document.name">{{ document.name }}</h4>
                                    <div class="doc-info-row">
                                        <mat-icon class="info-icon" matTooltip="Type">description</mat-icon>
                                        <span class="doc-value">{{ getDocumentType(document.type) }}</span>
                                    </div>
                                    <div class="doc-info-row">
                                        <mat-icon class="info-icon" matTooltip="Size">storage</mat-icon>
                                        <span class="doc-value">{{ document.size }}</span>
                                    </div>
                                    <div class="doc-info-row">
                                        <mat-icon class="info-icon" matTooltip="Uploaded by">person</mat-icon>
                                        <span class="doc-value">{{ document.uploadedBy }}</span>
                                    </div>
                                    <div class="doc-info-row">
                                        <mat-icon class="info-icon" matTooltip="Uploaded at">event</mat-icon>
                                        <span class="doc-value">{{ document.uploadedAt | date:'y-MM-dd h:mm a' }}</span>
                                    </div>
                                </mat-card-content>
                                <mat-card-actions align="end">
                                    <button mat-icon-button color="primary"
                                            (click)="downloadDocument(document.id); $event.stopPropagation()"
                                            matTooltip="Download">
                                        <mat-icon>download</mat-icon>
                                    </button>
                                    <button mat-icon-button color="warn"
                                            (click)="deleteDocument('MAIN_APPLICANT', document.type, document.name, document.id); $event.preventDefault(); $event.stopPropagation()"
                                            matTooltip="Delete" [disabled]="data?.isCollectorView">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </mat-card-actions>
                            </mat-card>
                        </div>
                    </mat-tab>
                    <mat-tab label="Co applicant" *ngIf="application.Co_Appl_Required === 'Yes'">
                        <table mat-table [dataSource]="dataSourceCoAppDocuments" *ngIf="currentView === 'list'" class="flat-table">
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef>Name</th>
                                <td mat-cell *matCellDef="let document">
                                    <a (click)="documentOnClick(document.id)" style="display: flex; align-items: center; gap: 8px;">
                                        <app-thumbnail
                                                [src]="document.thumbnailUrl"
                                                [alt]="document.name"
                                                [customStyle]="{height: '32px', width: '32px', 'object-fit': 'cover'}"
                                                [maxRetries]="5"
                                                [retryIntervalBase]="1000">
                                        </app-thumbnail>
                                        {{ document.name }}
                                    </a>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="type">
                                <th mat-header-cell *matHeaderCellDef>Type</th>
                                <td mat-cell *matCellDef="let document">{{ getDocumentType(document.type) }}</td>
                            </ng-container>

                            <ng-container matColumnDef="size">
                                <th mat-header-cell *matHeaderCellDef>Size</th>
                                <td mat-cell *matCellDef="let document">{{ document.size }}</td>
                            </ng-container>

                            <ng-container matColumnDef="uploadedInfo">
                                <th mat-header-cell *matHeaderCellDef>Uploaded</th>
                                <td mat-cell *matCellDef="let document">
                                    <div style="display: flex; flex-direction: column; gap: 4px;">
                                        <span style="font-weight: 500;">{{ document.uploadedBy }}</span>
                                        <span style="font-size: 0.85em; color: #666;">{{ document.uploadedAt | date:'y-MM-dd h:mm a' }}</span>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let document">
                                    <button mat-icon-button color="primary" (click)="downloadDocument(document.id); $event.stopPropagation()" matTooltip="Download">
                                        <mat-icon>download</mat-icon>
                                    </button>
                                    <button mat-icon-button color="warn"
                                            (click)="deleteDocument('CO_APPLICANT', document.type, document.name, document.id); $event.preventDefault(); $event.stopPropagation()" matTooltip="Delete" [disabled]="data?.isCollectorView">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsDocuments"></tr>
                            <tr mat-row *matRowDef="let document; columns: displayedColumnsDocuments"></tr>
                        </table>

                        <div *ngIf="currentView === 'grid'" class="documents-grid">
                            <mat-card class="document-content-card" *ngFor="let document of coAppDocuments"
                                      (click)="documentOnClick(document.id)">
                                <div class="card-thumbnail">
                                    <app-thumbnail
                                            [src]="document.thumbnailUrl"
                                            [alt]="document.name"
                                            [maxRetries]="5"
                                            [retryIntervalBase]="1000">
                                    </app-thumbnail>
                                </div>
                                <mat-card-content>
                                    <h4 class="doc-name" [matTooltip]="document.name">{{ document.name }}</h4>
                                    <div class="doc-info-row">
                                        <mat-icon class="info-icon" matTooltip="Type">description</mat-icon>
                                        <span class="doc-value">{{ getDocumentType(document.type) }}</span>
                                    </div>
                                    <div class="doc-info-row">
                                        <mat-icon class="info-icon" matTooltip="Size">storage</mat-icon>
                                        <span class="doc-value">{{ document.size }}</span>
                                    </div>
                                    <div class="doc-info-row">
                                        <mat-icon class="info-icon" matTooltip="Uploaded by">person</mat-icon>
                                        <span class="doc-value">{{ document.uploadedBy }}</span>
                                    </div>
                                    <div class="doc-info-row">
                                        <mat-icon class="info-icon" matTooltip="Uploaded at">event</mat-icon>
                                        <span class="doc-value">{{ document.uploadedAt | date:'y-MM-dd h:mm a' }}</span>
                                    </div>
                                </mat-card-content>
                                <mat-card-actions align="end">
                                    <button mat-icon-button color="primary"
                                            (click)="downloadDocument(document.id); $event.stopPropagation()"
                                            matTooltip="Download">
                                        <mat-icon>download</mat-icon>
                                    </button>
                                    <button mat-icon-button color="warn"
                                            (click)="deleteDocument('CO_APPLICANT', document.type, document.name, document.id); $event.preventDefault(); $event.stopPropagation()"
                                            matTooltip="Delete" [disabled]="data?.isCollectorView">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </mat-card-actions>
                            </mat-card>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- Upload menus -->
    <mat-menu #menu="matMenu">
        <button mat-menu-item [matMenuTriggerFor]="mainApplicant">Main applicant</button>
        <button mat-menu-item [matMenuTriggerFor]="coApplicant">Co applicant</button>
    </mat-menu>

    <mat-menu #mainApplicant="matMenu">
        <button mat-menu-item (click)="uploadFile('MAIN_APPLICANT', 'ID')">
            <span>ID</span>
        </button>
        <button mat-menu-item (click)="uploadFile('MAIN_APPLICANT', 'BANK_STATEMENT')">
            <span>Bank statement</span>
        </button>
        <button mat-menu-item (click)="uploadFile('MAIN_APPLICANT', 'NOA')">
            <span>NOA</span>
        </button>
        <button mat-menu-item (click)="uploadFile('MAIN_APPLICANT', 'PAYSTUB')">
            <span>Paystub</span>
        </button>
        <button mat-menu-item (click)="uploadFile('MAIN_APPLICANT', 'LETTER_OF_EMPLOYMENT')">
            <span>Letter of employment</span>
        </button>
        <button mat-menu-item (click)="uploadFile('MAIN_APPLICANT', 'SPEAK_ON_BEHALF')">
            <span>Speak on behalf</span>
        </button>
        <button mat-menu-item (click)="uploadFile('MAIN_APPLICANT', 'APPLY_ON_BEHALF')">
            <span>Apply on behalf</span>
        </button>
        <button mat-menu-item (click)="uploadFile('MAIN_APPLICANT', 'CONSENT_FORM')">
            <span>Consent form</span>
        </button>
        <button mat-menu-item (click)="uploadFile('MAIN_APPLICANT', 'VOID_CHEQUE')">
            <span>Void cheque</span>
        </button>
        <button mat-menu-item (click)="uploadFile('MAIN_APPLICANT', 'BALANCE_LETTER')">
            <span>Balance letter</span>
        </button>
        <button mat-menu-item (click)="uploadFile('MAIN_APPLICANT', 'OTHER')">
            <span>Other</span>
        </button>
    </mat-menu>

    <mat-menu #coApplicant="matMenu">
        <button mat-menu-item (click)="uploadFile('CO_APPLICANT', 'ID')">
            <span>ID</span>
        </button>
        <button mat-menu-item (click)="uploadFile('CO_APPLICANT', 'BANK_STATEMENT')">
            <span>Bank statement</span>
        </button>
        <button mat-menu-item (click)="uploadFile('CO_APPLICANT', 'NOA')">
            <span>NOA</span>
        </button>
        <button mat-menu-item (click)="uploadFile('CO_APPLICANT', 'PAYSTUB')">
            <span>Paystub</span>
        </button>
        <button mat-menu-item (click)="uploadFile('CO_APPLICANT', 'LETTER_OF_EMPLOYMENT')">
            <span>Letter of employment</span>
        </button>
        <button mat-menu-item (click)="uploadFile('CO_APPLICANT', 'SPEAK_ON_BEHALF')">
            <span>Speak on behalf</span>
        </button>
        <button mat-menu-item (click)="uploadFile('CO_APPLICANT', 'APPLY_ON_BEHALF')">
            <span>Apply on behalf</span>
        </button>
        <button mat-menu-item (click)="uploadFile('CO_APPLICANT', 'CONSENT_FORM')">
            <span>Consent form</span>
        </button>
        <button mat-menu-item (click)="uploadFile('CO_APPLICANT', 'VOID_CHEQUE')">
            <span>Void cheque</span>
        </button>
        <button mat-menu-item (click)="uploadFile('CO_APPLICANT', 'OTHER')">
            <span>Other</span>
        </button>
    </mat-menu>
</div>
